import React from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import toast from "react-hot-toast";
import axios from "axios";
import { useState } from "react";

function AadhaarOTPModal({
  setOpenOTPModal,
  sendOTPResponse,
  setLoad,
  setIsAadhaarVerified,
}) {
  const [otp, setOtp] = useState();
  console.log("sendOTPResponse: ", sendOTPResponse);
  const refID = sendOTPResponse?.ref_id;
  const handleSubmitOTP = (refID, otp) => {
    setLoad(true);
    const data = {
      otp: otp,
      ref_id: refID,
    };

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.CASHFREE_API_URL_TEST}/offline-aadhaar/verify`,
      headers: {
        "x-client-id": `${process.env.CLIENT_ID}`,
        "x-client-secret": `${process.env.SECRET_KEY}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Response of submitOTP: ", response.data);
        if (response.data.status === "VALID") {
          toast.success("AADHAAR verified successfully");
          setIsAadhaarVerified(true);
          setLoad(false);
          setOpenOTPModal(false);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        toast.error("OTP verification failed");
        setLoad(false);
      });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50  backdrop-blur-sm">
      <div className="relative h-[31rem] md:h-auto overflow-y-scroll md:overflow-y-hidden bg-white p-8 lg:py-8 lg:px-16 rounded-lg shadow-lg w-full max-w-xl">
        <div className="mb-6">
          <h2 className="text-xl font-semibold text-center">
            OTP has been sent to your AADHAAR registered mobile number
          </h2>
          <AiFillCloseCircle
            className="cursor-pointer text-primaryColor absolute top-4 right-4"
            size={28}
            onClick={() => setOpenOTPModal(false)}
          />
        </div>
        <form action="">
          <div className="mb-6">
            <label
              htmlFor="otp"
              className="block text-md font-medium text-primaryTextColor"
            >
              Enter OTP <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="otp"
              placeholder="OTP"
              className="border border-gray-300 p-2 outline-none  mt-1 block w-full rounded-md shadow-md sm:text-md"
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/[^0-9]/g, "")
                  .slice(0, 6);
                setOtp(e.target.value);
              }}
            />
          </div>

          <button
            type="submit"
            className="px-3 py-2 bg-green-500 hover:bg-green-600 text-white rounded-md float-right"
            onClick={() => handleSubmitOTP(otp, refID)}
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}

export default AadhaarOTPModal;
